import { Stack, Textarea } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";

import {
  INPUT_OUTPUT_DATE_LINK_ID,
  INPUT_OUTPUT_DATE_TIME_LINK_ID,
  INPUT_OUTPUT_INPUT_LINK_ID,
  INPUT_OUTPUT_NOTES_LINK_ID,
  INPUT_OUTPUT_OUTPUT_LINK_ID,
  INPUT_OUTPUT_TIME_LINK_ID,
} from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/constants/input-output-link-ids";
import type { InputOutputFlowsheetDrawerMode } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/types/input-output-drawer";
import type { InputOutputFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/types/input-output-form";
import { LABOR_FLOWSHEET_DRAWER_MODES } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/labor-flowsheet-drawer-constants";
import { LaborFlowsheetDateTimeFields } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/LaborFlowsheetDateTimeFields";
import { LaborFlowsheetSignatureInitialsField } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/LaborFlowsheetSignatureInitialsField";
import { questionnaireFieldTestId } from "@/intake-forms/utils/questionnaire-field-testid";

interface InputOutputFormFieldsProps {
  form: UseFormReturnType<InputOutputFlowsheetFormValues>;
  clientId: string;
  mode?: InputOutputFlowsheetDrawerMode;
}

export function InputOutputFormFields({
  form,
  clientId,
  mode = LABOR_FLOWSHEET_DRAWER_MODES.QuickAdd,
}: InputOutputFormFieldsProps) {
  const isQuickAddMode = mode === LABOR_FLOWSHEET_DRAWER_MODES.QuickAdd;

  return (
    <Stack gap="lg">
      <LaborFlowsheetDateTimeFields
        form={form}
        autoPopulateDateTime={isQuickAddMode}
        dateFieldName={INPUT_OUTPUT_DATE_LINK_ID}
        timeFieldName={INPUT_OUTPUT_TIME_LINK_ID}
        dateTimeGroupLinkId={INPUT_OUTPUT_DATE_TIME_LINK_ID}
      />

      <Textarea
        label="Input"
        data-path={INPUT_OUTPUT_INPUT_LINK_ID}
        {...form.getInputProps(INPUT_OUTPUT_INPUT_LINK_ID)}
        data-testid={questionnaireFieldTestId(INPUT_OUTPUT_INPUT_LINK_ID)}
      />

      <Textarea
        label="Output"
        data-path={INPUT_OUTPUT_OUTPUT_LINK_ID}
        {...form.getInputProps(INPUT_OUTPUT_OUTPUT_LINK_ID)}
        data-testid={questionnaireFieldTestId(INPUT_OUTPUT_OUTPUT_LINK_ID)}
      />

      <Textarea
        label="Notes"
        data-path={INPUT_OUTPUT_NOTES_LINK_ID}
        {...form.getInputProps(INPUT_OUTPUT_NOTES_LINK_ID)}
        data-testid={questionnaireFieldTestId(INPUT_OUTPUT_NOTES_LINK_ID)}
      />

      <LaborFlowsheetSignatureInitialsField
        form={form}
        clientId={clientId}
        label="Sign Initials"
        name="signatureInitials"
        autoPopulateSignature={isQuickAddMode}
      />
    </Stack>
  );
}
